export default "__VITE_ASSET__3HoB_cDe__"